import { format } from "date-fns";
import { today } from 'AppReact';
import { startOfWeek, endOfWeek, endOfMonth, eachDayOfInterval, isSameDay } from 'date-fns';

export const exportFileName = ({ status }) => {
  let date = `${format(today(), "MMddyy")}`;

  return `${status}_make_ready_${date}`;
}

const renderItem = (card, col) => {
  if (col.type === 'task') {
    const item = card?.items?.find((i) => i.name === col.name);
    if (!item) return "";
    const { scheduled, completed, notes } = item;
    // Completed task
    if (completed) return `Completed: ${format(completed, 'MM-dd-yyyy')}`;
    // Scheduled task, not yet completed
    if (scheduled) return `Scheduled: ${format(scheduled, 'MM-dd-yyyy')}`;
    // Unscheduled task, but has comments
    if (notes) return `Notes: ${notes}`;
    // Final fallback
    return "";
  }
  if (col.type === 'checkbox') {
    return card.card_data.find(d => d.category_id === col.id)?.data === 'true' ? 'Checked' : ''
  }
  if (col.type === 'textField') {
    return card.card_data.find(d => d.category_id === col.id)?.data ?? ''
  }
  if (col.type === 'floor_plan') {
    return card.unit.floor_plan ?? '-';
  }
  if (col.type === 'area') {
    return card.unit.area?.toString() ?? '-';
  }
  if (col.type === 'days_vacant') {
    return card.unit.days_vacant?.toString() ?? '-';
  }
  if (col.type === 'on_notice_resident_name') {
    return card.unit.on_notice_resident_name ?? '-';
  }
  if (col.type === 'on_notice_resident_phone') {
    return card.unit.on_notice_resident_phone ?? '-';
  }
  if (col.type === 'newResidentName') {
    return card.unit.new_resident_name ?? '-';
  }
  if (col.type === 'inspection_template') {
    let data = card.card_data.find(d => d.category_id === col.id);
    if (!data) {
      return '';
    }
    if (data.inspection_status === 'completed') {
      return 'Completed';
    }
    if (data.inspection_status === 'cancelled') {
      return 'Canceled';
    } else {
      return `${data.inspection_completed_items} completed / ${data.inspection_started_items} started out of ${data.inspection_num_items} items. ${data.inspection_assignee ? `Assigned to ${data.inspection_assignee}` : ''} `
    }
  }
  if (col.type === 'newResidentPhoneNumber') {
    return card.unit.new_resident_phone ?? '-';
  }
  if (col.type === 'marketRent') {
    return card.unit.market_rent ?? '-';
  }
  if (col.type === 'monetaryField') {
    let amount = card.card_data.find(d => d.category_id === col.id)?.data;
    return amount ? `$${amount}` : ''
  }
  if (col.type === 'date') {
    let date = card.card_data.find(d => d.category_id === col.id)?.data;
    return date ? format(new Date(date), 'MM/dd/yyyy') : ''
  }
  if (col.type === 'tags') {
    let date = card.card_data.find(d => d.category_id === col.id)?.tags;
    return date?.map(d => d.name)?.join(', ') ?? '';
  }

  return "";
};

export const csvData = ({ cards, makeReadyCategories }) => {
  return [[
    'Property',
    'Unit',
    'Move Out Date',
    'Ready Date',
    'Move In Date',
    ...(makeReadyCategories?.filter(col => col.active).map(column => column?.name === 'Maintenance Sign Off' ? 'Maintenance Complete' : column.name)),
    'Office Complete',
    'Add to Board',
    'Archived',

  ]].concat(
    cards.map((card) => {
      return [
        card.property.name,
        card.unit.number,
        card.move_out_date ? format(card.move_out_date, 'MM-dd-yyyy') : '',
        card.deadline ? format(card.deadline, 'MM-dd-yyyy') : '',
        card.move_in_date ? format(card.move_in_date, 'MM-dd-yyyy') : '',
        ...makeReadyCategories?.filter(col => col.active).map(col => renderItem(card, col)),
        card.completed_on ? `Completed: ${format(card.completed_on, 'MM-dd-yyyy')}` : '',
        card.inserted_at ? format(card.inserted_at, 'MM-dd-yyyy') : '',
        card.last_archived_at ? format(new Date(card.last_archived_at), 'MM-dd-yyyy') : '',
      ].map(v => `${v}`)
    }
    )
  );
}

export const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const calendarDates = (calendarSelectedDate) => {
  const start = startOfWeek(calendarSelectedDate)
  const end = endOfWeek(endOfMonth(calendarSelectedDate))
  return eachDayOfInterval({ start, end })
}

export const moveOutsForDate = ({ selectedDate, cards }) => {
  return cards.filter(card => isSameDay(card.move_out_date, selectedDate));
}

export const moveInsForDate = ({ selectedDate, cards }) => {
  return cards.filter(card => isSameDay(card.move_in_date, selectedDate));
}

export const ordersForDate = ({ selectedDate, cards }) => {
  return cards.filter(card => card.items.find(item => isSameDay(item.scheduled, selectedDate)));
}
